import { AccordionDetails, Alert, AlertTitle, Box, Button, CircularProgress, FormControl, InputLabel, MenuItem, Select, TextField, Typography } from "@mui/material";
import { Delete } from "@mui/icons-material";
import { IMarketplace } from "../../../../../interfaces/IMarketplace";
import { IEstabelecimentoIFood } from "../../../../../interfaces/IEstabelecimentoIFood";
import { useMarketplaces } from "../../../../../hooks/useMarketplaces";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ConfirmacaoAcaoModal } from "../../../../../../core/components/ConfirmacaoAcaoModal";

interface PrimeiraEtapaVinculoIFoodProps {
    estabelecimentoConfigurado: string | undefined;
    marketplaceUuid: string | undefined;
    vincular: (merchantId: string) => void;
    loading: boolean;
}

export const PrimeiraEtapaVinculoIFood = ({
    estabelecimentoConfigurado,
    marketplaceUuid,
    vincular,
    loading
}: PrimeiraEtapaVinculoIFoodProps) => {
    const [merchantId, setMerchantId] = useState('');
    const [modalExclusaoOpen, setModalExclusaoOpen] = useState(false);

    const navigate = useNavigate();
    const { inativar, loading: loadingExcluir } = useMarketplaces();

    useEffect(() => {
        if(estabelecimentoConfigurado) {
            setMerchantId(estabelecimentoConfigurado);
        }
    }, [estabelecimentoConfigurado])

    const handleExcluirMarketplace = async () => {
        if(!marketplaceUuid) return;

        const excluido = await inativar(marketplaceUuid);
        if(excluido) {
            navigate("/marketplace");
        }
    }

    return (
        <>
            <ConfirmacaoAcaoModal
                open={modalExclusaoOpen}
                titulo="Excluir marketplace"
                descricao="Tem certeza que deseja excluir este marketplace do iFood? Essa ação não pode ser desfeita."
                loading={loadingExcluir}
                onConfirmar={handleExcluirMarketplace}
                onCancelar={() => setModalExclusaoOpen(false)}
            />
            <Box>
                <Typography variant="h6">Estabelecimento</Typography>
                <Typography variant="subtitle2" fontWeight={400} color={"GrayText"} sx={{ mt: "1rem" }}>
                    Configure o Merchant ID do IFood.
                </Typography>
                <FormControl style={{ width: '100%', margin: "0.7rem 0" }}>
                    <TextField
                        value={merchantId}
                        onChange={(e) => setMerchantId(e.target.value)}
                    />
                </FormControl>
                <Box sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    marginTop: '1rem'
                }}>
                    <Button
                        onClick={() => setModalExclusaoOpen(true)}
                        color="error"
                        startIcon={<Delete />}
                        disabled={!marketplaceUuid || loadingExcluir}
                    >
                        Excluir marketplace
                    </Button>
                    <Button onClick={() => vincular(merchantId)} variant="contained" color="primary">
                        {loading ? <CircularProgress size={20} color="inherit" /> : "Vincular"}
                    </Button>
                </Box>
            </Box>
        </>
    );
};
